import { render, staticRenderFns } from "./RSEblock.vue?vue&type=template&id=5926fb7a"
import script from "./RSEblock.vue?vue&type=script&setup=true&lang=ts"
export * from "./RSEblock.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports